export interface LegacyTacCalibration {
  calib?: unknown;
  crop?: unknown;
}

export const LEGACY_TAC_CALIBRATIONS = {
  "assets/maps/Belgrade/minimap.webp": {
    calib: [
      { p: [0.6646808035509058, 0.13319147594999398], w: [167.740265, 375.64267] },
      { p: [0.48148932370505093, 0.3361701888105578], w: [-19.475048, 166.855118] },
      { p: [0.5140425135034432, 0.39170210081958], w: [13.740363, 111.514687] },
    ],
  },
  "assets/maps/Bridge_at_Remagen/minimap.webp": {
    calib: [
      { p: [0.5063829394332333, 0.24234040645048588], w: [13.852608, 528.94696] },
      { p: [0.5063829394332333, 0.6514893311071865], w: [13.541454, -312.023468] },
      { p: [0.6672339949076423, 0.46255317070867424], w: [343.366089, 76.459648] },
    ],
  },
  "assets/maps/Camp_Gibraltar/minimap.webp": {
    calib: [
      { p: [0.5994456835887476, 0.47253014064702437], w: [206.129684, 57.150772] },
      { p: [0.6004238380982345, 0.5258395614140613], w: [206.15184, -53.129128] },
      { p: [0.5573850396808102, 0.49356046260099307], w: [115.851418, 13.129444] },
    ],
    crop: { u0: 0.3663, u1: 0.687, v0: 0.2763, v1: 0.5316 },
  },
  "assets/maps/Cerbere_Landing/minimap.webp": {
    calib: [
      { p: [0.48468081290097176, 0.4204255035828674], w: [-15.72655, 81.278206] },
      { p: [0.4744680474740251, 0.49382975508904614], w: [-26.401354, 5.782957] },
      { p: [0.5229786832520216, 0.55574464548991], w: [23.163881, -58.092041] },
    ],
    crop: { u0: 0.3685, u1: 0.7728, v0: 0.2198, v1: 0.8043 },
  },
  "assets/maps/Fall_of_Berlin/minimap.webp": {
    calib: [
      { p: [0.6142552742553569, 0.5470400839160418], w: [115.878677, -48.599354] },
      { p: [0.5848935736528853, 0.5834016335992219], w: [86.349655, -85.928444] },
      { p: [0.521063789734469, 0.5865912432205536], w: [22.239374, -88.075882] },
    ],
    crop: { u0: 0.2489, u1: 0.8337, v0: 0.3918, v1: 0.7047 },
  },
  "assets/maps/Highway_Tampa/minimap.webp": {
    calib: [
      { p: [0.3397872034061667, 0.1344680716283623], w: [-329.162537, 749.328247] },
      { p: [0.3538297558682183, 0.7619148572860467], w: [-299.816803, -537.166626] },
      { p: [0.5510637881761247, 0.7995744297979124], w: [105.600365, -613.431274] },
    ],
  },
  "assets/maps/Liberation_of_Leipzig/minimap.webp": {
    calib: [
      { p: [0.5919148498839112, 0.6578723094990281], w: [93.819641, -163.209625] },
      { p: [0.5657446384773605, 0.4217021090008878], w: [68.507225, 79.54023] },
      { p: [0.4470212403891061, 0.5353191243756689], w: [-54.616322, -36.948235] },
    ],
  },
  "assets/maps/Minsk/minimap.webp": {
    calib: [
      { p: [0.7348935658611637, 0.6399999700018716], w: [483.874786, -286.27774] },
      { p: [0.4182978376258188, 0.6029786953291901], w: [-166.773453, -211.526306] },
      { p: [0.528723363804679, 0.3661701969918656], w: [61.113155, 274.468903] },
    ],
  },
  "assets/maps/Operation_Blue_Pearl/minimap.webp": {
    calib: [
      { p: [0.6665956970684582, 0.5525531635987282], w: [169.606659, -53.615864] },
      { p: [0.45531911229850025, 0.5882978425930413], w: [-45.319641, -90.566475] },
      { p: [0.37106379752619073, 0.6897871990233233], w: [-131.367432, -193.445679] },
    ],
  },
  "assets/maps/Operation_Shingle/minimap.webp": {
    calib: [
      { p: [0.521063789734469, 0.5780850796010077], w: [21.448723, -80.25856] },
      { p: [0.528723363804679, 0.5231914654311697], w: [29.608217, -24.678612] },
      { p: [0.41638294410826626, 0.4906382756327774], w: [-85.658981, 8.501115] },
    ],
  },
  "assets/maps/Port_Bavaria/minimap.webp": {
    calib: [
      { p: [0.33212762933595674, 0.7606382713473305], w: [-344.80423, -534.703796] },
      { p: [0.5772339995826754, 0.7542552929554889], w: [159.920944, -521.523315] },
      { p: [0.5031914502373125, 0.8902127327017156], w: [6.334697, -802.407898] },
    ],
  },
  "assets/maps/Shuhia_Taiba/minimap.webp": {
    calib: [
      { p: [0.7680850534987401, 0.6380850862239712], w: [551.644104, -284.476288] },
      { p: [0.5089361307899699, 0.49319147672916613], w: [16.910425, 15.378793] },
      { p: [0.16106380843460105, 0.371276589444991], w: [-695.594849, 265.286926] },
    ],
  },
  "assets/maps/Sidi_Power_Plant/minimap.webp": {
    calib: [
      { p: [0.36148932993842825, 0.5219148673178884], w: [-283.749908, -45.750011] },
      { p: [0.4693616647605518, 0.500851038624811], w: [-63.894146, -3.628279] },
      { p: [0.6027659131500419, 0.4172340216916856], w: [208.699799, 169.943558] },
    ],
  },
  "assets/maps/Strike_at_Karkand/minimap.webp": {
    calib: [
      { p: [0.6506382510888541, 0.19595743662953807], w: [154.343735, 312.034637] },
      { p: [0.14829785165091777, 0.35617019426476304], w: [-359.582153, 146.27211] },
      { p: [0.3346808206926934, 0.5374467805930654], w: [-169.404037, -39.624771] },
    ],
  },
  "assets/maps/Tunis_Harbor/minimap.webp": {
    calib: [
      { p: [0.3391489055669826, 0.5538297617120096], w: [-166.045593, -56.055279] },
      { p: [0.6002127217933052, 0.6840425209055788], w: [102.310097, -189.532196] },
      { p: [0.7125531414897179, 0.5206382740744331], w: [217.902542, -22.038431] },
    ],
  },
  "assets/maps/Verdun/minimap.webp": {
    calib: [
      { p: [0.1789361479317576, 0.5736169849870665], w: [-656.827087, -150.903275] },
      { p: [0.41574464626908214, 0.4651063523257588], w: [-171.322342, 70.489258] },
      { p: [0.47063826043892015, 0.6080850780426634], w: [-58.793446, -223.238617] },
    ],
  },
  "assets/maps/Wake_Island_2142/minimap.webp": {
    calib: [
      { p: [0.293829758984907, 0.4540425300121535], w: [-420.616089, 91.41507] },
      { p: [0.7355318637003478, 0.7023403894547929], w: [485.275391, -414.314026] },
      { p: [0.6717020797819315, 0.393404235289658], w: [355.579254, 213.609772] },
    ],
  },
  "assets/maps/Yellow_Knife/minimap.webp": {
    calib: [
      { p: [0.6985105890276664, 0.32021274283095374], w: [202.374176, 186.579498] },
      { p: [0.7406382464138211, 0.35468082614689855], w: [248.678665, 148.279465] },
      { p: [0.6085105937026993, 0.44851060850697055], w: [109.742897, 51.823647] },
    ],
  },
  "assets/maps/suez_canal/minimap.webp": {
    calib: [
      { p: [0.3171874567270312, 0.5253124551534687], w: [-376.230652, -49.993965] },
      { p: [0.4390624474287073, 0.5149999559402499], w: [-124.982307, -31.738623] },
      { p: [0.4596874458551448, 0.47468745901584936], w: [-85.092384, 54.087685] },
    ],
  },
} as const satisfies Record<string, LegacyTacCalibration>;

export function normalizeTacCalibrationKey(value: string | null | undefined): string {
  const clean = String(value ?? "").replace(/^\/+/, "");
  const parts = clean.split("/");
  if (parts.length < 4) return "";
  const filename = parts.at(-1)?.toLowerCase();
  const mapDir = parts.at(-2) ?? "";
  if (filename !== "minimap.webp" || !mapDir) return "";
  const mapKey = mapDir.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  return `assets/maps/${mapKey}/minimap.webp`;
}

export function lookupLegacyTacCalibration(image: string | null | undefined): LegacyTacCalibration | null {
  const wanted = normalizeTacCalibrationKey(image);
  if (!wanted) return null;
  for (const [key, value] of Object.entries(LEGACY_TAC_CALIBRATIONS)) {
    if (normalizeTacCalibrationKey(key) === wanted) return value;
  }
  return null;
}

export function resolveTacCalibration(runtimeCalib: unknown, image: string | null | undefined): unknown {
  return runtimeCalib ?? lookupLegacyTacCalibration(image)?.calib ?? null;
}

/**
 * Per-Map-Crop/Viewport (`{u0,u1,v0,v1}`, normalisierte Vollbild-Koordinaten).
 * Runtime-`tac_maps.json`-Crop hat Vorrang vor dem Legacy-Seed; sonst null
 * (= aktuelles Cover-Verhalten ohne Zoom-Ausschnitt).
 */
export function resolveTacCrop(runtimeCrop: unknown, image: string | null | undefined): unknown {
  return runtimeCrop ?? lookupLegacyTacCalibration(image)?.crop ?? null;
}

export type TacCalibrationSource = "manual" | "legacy" | "missing";

export function tacCalibrationSource(runtimeCalib: unknown, image: string | null | undefined): TacCalibrationSource {
  if (runtimeCalib) return "manual";
  return lookupLegacyTacCalibration(image)?.calib ? "legacy" : "missing";
}
